/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { ReactComponent as TensaiIcon } from '../../assets/images/icons/tensai-logo.svg';
import { toast } from 'react-toastify';
import { connect, useSelector } from 'react-redux';
import * as yup from 'yup';
import { ThemeProvider } from 'styled-components';
import { Logo, Button } from '../../components';
import { updateSession } from '../../stores/actions/access';
import { PageWrapper, Content, Footer, InputField, ContentWrapper, ImageWrapper, IconWrapper, IconBtn, CheckboxWrapper, CheckboxButton, Square, OptionsWrapper, CheckboxText } from './styles';
import light from '../../assets/style/themes/dark';
import loginBackground from '../../assets/images/login-background.png'
import { EyeWatermarkIcon, HiddenEyeWatermarkIcon } from 'src/components/Icons';
import { ValidationWrapper } from './styles';
import { ValidationContent } from './styles';
import ClockIcon from 'src/components/Icons/clock';
import ClockCheckIcon from 'src/components/Icons/clockCheck';
import { validadeCharacter, validadeLength, validadeLowerCase, validadeNumbers, validadeUpperCase, validatorAll } from './utils';
import TensaiService from 'src/services/tensai';
import { AuthService } from 'src/services';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';


const resStringAccess = 'Confirmar';
const errNotPermission = 'Não foi possível realizar a troca de senha, verifique seus dados de acesso!';
const errFailOnRequest = 'Houve uma falha na requisição ou no servidor';

const tensaiService = new TensaiService()
const authService = new AuthService()

/**
 * Create validation scheme
 */
const schema = yup.object().shape({
  password: yup
    .string()
    .required('Campo obrigatório')
    .min(8, 'A senha deve ter pelo menos 8 caracteres')
    .matches(/[A-Z]/, 'O campo deve conter pelo menos uma letra maiúscula')
    .matches(/[a-z]/, 'O campo deve conter pelo menos uma letra minúscula')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'O campo deve conter pelo menos um caractere especial'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'As senhas não correspondem')
    .required('Campo obrigatório'),
});

/**
 * FirstLogin
 */
function FirstLogin({ dispatch, running, error, authenticated, needChangePassword, name }) {
  const date = new Date()?.getFullYear();
  
  const history = useHistory();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const token = params.get("token");

  const [isTokenValid, setIsTokenValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmePassword, setShowConfirmePassword] = useState(false);

  const theme = light;

  // initial values
  const initialValues = {
    password: '',
    confirmPassword: '',
  };

  /**
   * Fluxo 1: authenticated = true: fluxo de redefinição no primeiro acesso do usuárion
   * Fluxo 2: authenticated = false && token = true: fluxo de redefinição de senha
   * Fluxo 3: authenticated = false && token = false: fluxo de redefinição não autorizado
   */
  useEffect(() => {
    if (!authenticated && token) {
      const service = new TensaiService();
      service.verifyTokenForPasswordChange(token)
      .then((status) => {
        if (status === 200) {
          setIsTokenValid(true);
        }
      })
      .catch((error) => {
        console.error("Erro ao verificar token:", error);
        history.push('/'); 
      });
    } else if (!authenticated && !token) { 
      history.push('/'); 
    }
  }, [token, authenticated]);

  // handle submit click
  function handleSubmit(values) {
    if(!authenticated && isTokenValid) {
      updateSession(values, dispatch, token);
    } else {
      updateSession(values, dispatch);
    }
  }

  // error effect
  useEffect(() => {
    const callback = () => window.location.reload();

    if (error) {
      // check error type
      // Foi adicionado a verificação de existência do atributo "status" do objeto errResp
      // no intuito de quando a requisição da API fica com status "pending"
      // e o erro da API não retorna status code em decorrência de timeout
      // ai o navegador estava retornando um erro tentando acessar a propriedade
      // "pending" de um objeto undefined
      const errResp = error.response;
      if (errResp.status && errResp.status === 400) {
        toast.error(errNotPermission);
        authService.removeToken(callback);
      } else if (errResp.status && errResp.status > 500) {
        toast.error(errFailOnRequest);
      } else {
        toast.error(errNotPermission);
      }
      // reload page
      history.push('/');
    } else if (authenticated && !needChangePassword) {
      // redirect to app
      history.push('/app');
      // reload page
    }
  }, [error, authenticated, needChangePassword, history]);
  
/**
 * Renderiza o conteúdo de boas-vindas da tela de redefinição de senha.
 * - Se o usuário está autenticado, exibe uma mensagem personalizada com o nome.
 * - Caso contrário, mostra uma mensagem genérica de boas-vindas.
 */
function renderWelcomeMessage() {
  if (authenticated) {
    const userName = name ?? tensaiService.getData(authService.getToken()).name;

    return (
      <>
        <h1>Olá, {userName}</h1>
        <h3>
          Este é o seu primeiro acesso ao Analyze. <br />
          Vamos começar redefinindo sua senha.
        </h3>
      </>
    );
  }

  return (
    <>
      <h1>Bom te ver de novo</h1>
      <h3>Vamos começar redefinindo sua senha.</h3>
    </>
  );
}

  return (
    <ThemeProvider theme={theme}>
      <PageWrapper>
        <ContentWrapper>
          <Content>
            <Logo />
            { renderWelcomeMessage() }
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validationSchema={schema}
            >
              {({ isValid, values, errors }) => (
                <Form className="form">
                  <InputField>
                    <IconWrapper>
                      <IconBtn onClick={() => setShowPassword(state => !state)}>
                        {showPassword
                          ? <EyeWatermarkIcon className='eyeIcon' />
                          : <HiddenEyeWatermarkIcon className='eyeIcon' />
                        }
                      </IconBtn>
                      <Field name="password">
                        {({ field }) => (
                          <input
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Digite sua nova senha*"
                            {...field}
                          />
                        )}
                      </Field>
                    </IconWrapper>
                    {values.password && (
                      <ValidationWrapper>
                        <h4>A nova senha deve conter:</h4>
                        <ValidationContent>
                          <p>{validadeLength(values.password) ? <ClockCheckIcon /> : <ClockIcon />}<span>Ao menos 8 caracteres</span></p>
                          <p>{validadeLowerCase(values.password) ? <ClockCheckIcon /> : <ClockIcon />}<span>Ao menos 1 letra minúscula</span></p>
                          <p>{validadeNumbers(values.password) ? <ClockCheckIcon /> : <ClockIcon />}<span>Ao menos 2 números</span></p>
                          <p>{validadeCharacter(values.password) ? <ClockCheckIcon /> : <ClockIcon />}<span>Ao menos 1 caractere especial</span></p>
                          <p>{validadeUpperCase(values.password) ? <ClockCheckIcon /> : <ClockIcon />}<span>Ao menos 1 letra maiúscula</span></p>
                        </ValidationContent>
                      </ValidationWrapper>
                    )}
                  </InputField>
                  <InputField>
                    <IconWrapper>
                      <IconBtn onClick={() => setShowConfirmePassword(state => !state)}>
                        {showConfirmePassword
                          ? <EyeWatermarkIcon className='eyeIcon' />
                          : <HiddenEyeWatermarkIcon className='eyeIcon' />
                        }
                      </IconBtn>
                      <Field
                        name="confirmPassword"
                        type={showConfirmePassword ? 'text' : 'password'}
                        className={errors.confirmPassword ? 'errorInput' : ''}
                        placeholder="Repetir nova senha*"
                      />
                    </IconWrapper>
                    <ErrorMessage name="confirmPassword">
                      {(msg) => <div className="errorMessage">{msg}</div>}
                    </ErrorMessage>
                  </InputField>

                  <div className="action">
                    <Button
                      title={resStringAccess}
                      type="submit"
                      loading={running}
                      disable={
                        !isValid ||
                        !validatorAll(values.password)
                      }
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </Content>
          <Footer>
            <div className="copyright">
              <span> Distribuído por &copy; {date} Tensai. Todos os direitos reservados</span>
            </div>
          </Footer>
        </ContentWrapper>
        <ImageWrapper>
          <img src={loginBackground} alt="Imagem de uma pessoa usando o computador" />
        </ImageWrapper>
      </PageWrapper>
    </ThemeProvider>
  );
}

// [required]
const mapStateToProps = (state) => {
  const accessState = state.access;
  return {
    running: accessState.running,
    error: accessState.error,
    authenticated: accessState.payload ? accessState.payload.authenticated : null,
    needChangePassword: accessState.needChangePassword,
    name: accessState.payload.name,
  };
};

export default connect(mapStateToProps)(FirstLogin);
